import { formatNumber, formatShortDate } from "../lib/format";
import { Button } from "./ui/button";

interface ActivityFeedStripProps {
  latestFilingDate: string | null;
  sinceLabel: string;
  newHighScoreBuys: number;
  newClusters: number;
  watchlistHits: number;
  onOpenToday: () => void;
  onOpenActionQueue: () => void;
  onOpenWorkspace: () => void;
}

export function ActivityFeedStrip({
  latestFilingDate,
  sinceLabel,
  newHighScoreBuys,
  newClusters,
  watchlistHits,
  onOpenToday,
  onOpenActionQueue,
  onOpenWorkspace
}: ActivityFeedStripProps) {
  return (
    <section
      aria-label="Desk pulse"
      className="border-b border-border bg-surface-inset px-3 py-2"
    >
      <div className="flex flex-wrap items-center gap-2 text-[11px]">
        <span className="font-semibold uppercase tracking-[0.12em] text-muted-foreground">
          Desk pulse
        </span>
        <span className="text-muted-foreground">{sinceLabel}</span>
        {latestFilingDate ? (
          <span className="tabular-nums text-muted-foreground">
            Latest filing {formatShortDate(latestFilingDate)}
          </span>
        ) : null}
        <span className="rounded-md border border-border bg-background px-2 py-0.5 tabular-nums">
          High-score buys {formatNumber(newHighScoreBuys)}
        </span>
        <span className="rounded-md border border-border bg-background px-2 py-0.5 tabular-nums">
          Clusters {formatNumber(newClusters)}
        </span>
        <span className="rounded-md border border-border bg-background px-2 py-0.5 tabular-nums">
          Watchlist hits {formatNumber(watchlistHits)}
        </span>
        <div className="ml-auto flex flex-wrap gap-1">
          <Button type="button" size="sm" variant="outline" className="h-6 px-2" onClick={onOpenToday}>
            Today
          </Button>
          <Button
            type="button"
            size="sm"
            variant="outline"
            className="h-6 px-2"
            onClick={onOpenActionQueue}
          >
            Action queue
          </Button>
          <Button
            type="button"
            size="sm"
            variant="outline"
            className="h-6 px-2"
            onClick={onOpenWorkspace}
          >
            Alerts
          </Button>
        </div>
      </div>
    </section>
  );
}
